import styles from "./PrivacyPolicy.module.scss";

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className={styles.privacyPolicy}>
      <h1 className={styles.title}>Datenschutzerklärung</h1>
      <h3 id="m716">Präambel</h3>
      <p>
        Mit der folgenden Datenschutzerklärung möchten wir Sie darüber
        aufklären, welche Arten Ihrer personenbezogenen Daten (nachfolgend auch
        kurz als "Daten" bezeichnet) wir zu welchen Zwecken und in welchem
        Umfang verarbeiten. Die Datenschutzerklärung gilt für alle von uns
        durchgeführten Verarbeitungen personenbezogener Daten, sowohl im Rahmen
        der Erbringung unserer Leistungen als auch insbesondere auf unseren
        Webseiten, in mobilen Applikationen sowie innerhalb externer
        Onlinepräsenzen, wie z. B. unserer Social-Media-Profile (nachfolgend
        zusammenfassend bezeichnet als "Onlineangebot").
      </p>
      <p>Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</p>
      <p>Stand: 25. September 2024</p>
      <h3>Inhaltsübersicht</h3>
      <ul>
        <li>
          <a href="#m716">Präambel</a>
        </li>
        <li>
          <a href="#m3">Verantwortlicher</a>
        </li>
        <li>
          <a href="#mOverview">Übersicht der Verarbeitungen</a>
        </li>
        <li>
          <a href="#m2427">Maßgebliche Rechtsgrundlagen</a>
        </li>
        <li>
          <a href="#m27">Sicherheitsmaßnahmen</a>
        </li>
        <li>
          <a href="#m25">Übermittlung von personenbezogenen Daten</a>
        </li>
        <li>
          <a href="#m326">Zahlungsverfahren</a>
        </li>
        <li>
          <a href="#m225">Bereitstellung des Onlineangebots und Webhosting</a>
        </li>
        <li>
          <a href="#m182">Kontakt- und Anfrageverwaltung</a>
        </li>
        <li>
          <a href="#m136">Präsenzen in sozialen Netzwerken (Social Media)</a>
        </li>
      </ul>
      <h3 id="m3">Verantwortlicher</h3>
      <div>Verena Tewes</div>
      <div>Jakob-Ruppert-Str. 9</div>
      <div>69214 Eppelheim</div>
      <p>
        E-Mail-Adresse:
        <a href="mailto:vtewes@outlook.com">vtewes@outlook.com</a>
      </p>
      <p>Impressum: verena-tewes.de/impressum</p>
      <h3 id="mOverview">Übersicht der Verarbeitungen</h3>
      <p>
        Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und
        die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen
        Personen.
      </p>
      <h3>Arten der verarbeiteten Daten</h3>
      <ul>
        <li>Bestandsdaten.</li>
        <li>Kontaktdaten.</li>
        <li>Inhaltsdaten.</li>
        <li>Nutzungsdaten.</li>
        <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
        <li>Protokolldaten.</li>
      </ul>
      <h3>Kategorien betroffener Personen</h3>
      <ul>
        <li>Kommunikationspartner.</li>
        <li>Nutzer.</li>
      </ul>
      <h3>Zwecke der Verarbeitung</h3>
      <ul>
        <li>Kommunikation.</li>
        <li>Sicherheitsmaßnahmen.</li>
        <li>Organisations- und Verwaltungsverfahren.</li>
        <li>Feedback.</li>
        <li>
          Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.
        </li>
        <li>Informationstechnische Infrastruktur.</li>
        <li>Öffentlichkeitsarbeit.</li>
      </ul>
      <h3 id="m2427">Maßgebliche Rechtsgrundlagen</h3>
      <p>
        <strong>Maßgebliche Rechtsgrundlagen nach der DSGVO: </strong>Im
        Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der DSGVO,
        auf deren Basis wir personenbezogene Daten verarbeiten. Bitte nehmen Sie
        zur Kenntnis, dass neben den Regelungen der DSGVO nationale
        Datenschutzvorgaben in Ihrem bzw. unserem Wohn- oder Sitzland gelten
        können. Sollten ferner im Einzelfall speziellere Rechtsgrundlagen
        maßgeblich sein, teilen wir Ihnen diese in der Datenschutzerklärung mit.
      </p>
      <ul>
        <li>
          <strong>
            Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
            lit. b) DSGVO)
          </strong>
          - Die Verarbeitung ist für die Erfüllung eines Vertrags, dessen
          Vertragspartei die betroffene Person ist, oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich, die auf Anfrage der
          betroffenen Person erfolgen.
        </li>
        <li>
          <strong>
            Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO)
          </strong>
          - die Verarbeitung ist zur Wahrung der berechtigten Interessen des
          Verantwortlichen oder eines Dritten notwendig, vorausgesetzt, dass die
          Interessen, Grundrechte und Grundfreiheiten der betroffenen Person,
          die den Schutz personenbezogener Daten verlangen, nicht überwiegen.
        </li>
      </ul>
      <p>
        <strong>Nationale Datenschutzregelungen in Deutschland: </strong>
        Zusätzlich zu den Datenschutzregelungen der DSGVO gelten nationale
        Regelungen zum Datenschutz in Deutschland. Hierzu gehört insbesondere
        das Gesetz zum Schutz vor Missbrauch personenbezogener Daten bei der
        Datenverarbeitung (Bundesdatenschutzgesetz – BDSG). Das BDSG enthält
        insbesondere Spezialregelungen zum Recht auf Auskunft, zum Recht auf
        Löschung, zum Widerspruchsrecht, zur Verarbeitung besonderer Kategorien
        personenbezogener Daten, zur Verarbeitung für andere Zwecke und zur
        Übermittlung sowie automatisierten Entscheidungsfindung im Einzelfall
        einschließlich Profiling. Ferner können Landesdatenschutzgesetze der
        einzelnen Bundesländer zur Anwendung gelangen.
      </p>
      <p>
        <strong>Hinweis auf Geltung DSGVO und Schweizer DSG: </strong>Diese
        Datenschutzhinweise dienen sowohl der Informationserteilung nach dem
        Schweizer DSG als auch nach der Datenschutzgrundverordnung (DSGVO). Aus
        diesem Grund bitten wir Sie zu beachten, dass aufgrund der breiteren
        räumlichen Anwendung und Verständlichkeit die Begriffe der DSGVO
        verwendet werden. Insbesondere statt der im Schweizer DSG verwendeten
        Begriffe „Bearbeitung" von „Personendaten", "überwiegendes Interesse"
        und "besonders schützenswerte Personendaten" werden die in der DSGVO
        verwendeten Begriffe „Verarbeitung" von „personenbezogenen Daten" sowie
        "berechtigtes Interesse" und "besondere Kategorien von Daten" verwendet.
        Die gesetzliche Bedeutung der Begriffe wird jedoch im Rahmen der Geltung
        des Schweizer DSG weiterhin nach dem Schweizer DSG bestimmt.
      </p>
      <h3 id="m27">Sicherheitsmaßnahmen</h3>
      <p>
        Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter
        Berücksichtigung des Stands der Technik, der Implementierungskosten und
        der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie
        der unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der
        Bedrohung der Rechte und Freiheiten natürlicher Personen geeignete
        technische und organisatorische Maßnahmen, um ein dem Risiko
        angemessenes Schutzniveau zu gewährleisten.
      </p>
      <p>
        Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit,
        Integrität und Verfügbarkeit von Daten durch Kontrolle des physischen
        und elektronischen Zugangs zu den Daten als auch des sie betreffenden
        Zugriffs, der Eingabe, der Weitergabe, der Sicherung der Verfügbarkeit
        und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die
        eine Wahrnehmung von Betroffenenrechten, die Löschung von Daten und
        Reaktionen auf die Gefährdung der Daten gewährleisten. Ferner
        berücksichtigen wir den Schutz personenbezogener Daten bereits bei der
        Entwicklung bzw. Auswahl von Hardware, Software sowie Verfahren
        entsprechend dem Prinzip des Datenschutzes, durch Technikgestaltung und
        durch datenschutzfreundliche Voreinstellungen.
      </p>
      <p>
        Sicherung von Online-Verbindungen durch
        TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um die Daten der Nutzer,
        die über unsere Online-Dienste übertragen werden, vor unerlaubten
        Zugriffen zu schützen, setzen wir auf die
        TLS-/SSL-Verschlüsselungstechnologie. Secure Sockets Layer (SSL) und
        Transport Layer Security (TLS) sind die Eckpfeiler der sicheren
        Datenübertragung im Internet. Diese Technologien verschlüsseln die
        Informationen, die zwischen der Website oder App und dem Browser des
        Nutzers (oder zwischen zwei Servern) übertragen werden, wodurch die
        Daten vor unbefugtem Zugriff geschützt sind. TLS, als die
        weiterentwickelte und sicherere Version von SSL, gewährleistet, dass
        alle Datenübertragungen den höchsten Sicherheitsstandards entsprechen.
        Wenn eine Website durch ein SSL-/TLS-Zertifikat gesichert ist, wird dies
        durch die Anzeige von HTTPS in der URL signalisiert. Dies dient als ein
        Indikator für die Nutzer, dass ihre Daten sicher und verschlüsselt
        übertragen werden.
      </p>
      <h3 id="m25">Übermittlung von personenbezogenen Daten</h3>
      <p>
        Im Rahmen unserer Verarbeitung von personenbezogenen Daten kommt es vor,
        dass diese an andere Stellen, Unternehmen, rechtlich selbstständige
        Organisationseinheiten oder Personen übermittelt beziehungsweise ihnen
        gegenüber offengelegt werden. Zu den Empfängern dieser Daten können
        z. B. mit IT-Aufgaben beauftragte Dienstleister gehören oder Anbieter
        von Diensten und Inhalten, die in eine Website eingebunden sind. In
        solchen Fällen beachten wir die gesetzlichen Vorgaben und schließen
        insbesondere entsprechende Verträge bzw. Vereinbarungen, die dem Schutz
        Ihrer Daten dienen, mit den Empfängern Ihrer Daten ab.
      </p>
      <h3 id="m326">Zahlungsverfahren</h3>
      <p>
        Im Rahmen von Vertrags- und sonstigen Rechtsbeziehungen, aufgrund
        gesetzlicher Pflichten oder sonst auf Grundlage unserer berechtigten
        Interessen bieten wir den betroffenen Personen effiziente und sichere
        Zahlungsmöglichkeiten an und setzen hierzu neben Banken und
        Kreditinstituten weitere Dienstleister ein (zusammenfassend
        "Zahlungsdienstleister").
      </p>
      <p>
        Zu den durch die Zahlungsdienstleister verarbeiteten Daten gehören
        Bestandsdaten, wie z.B. der Name und die Adresse, Bankdaten, wie z. B.
        Kontonummern oder Kreditkartennummern, Passwörter, TANs und Prüfsummen
        sowie die Vertrags-, Summen- und empfängerbezogenen Angaben. Die Angaben
        sind erforderlich, um die Transaktionen durchzuführen. Die eingegebenen
        Daten werden jedoch nur durch die Zahlungsdienstleister verarbeitet und
        bei diesen gespeichert. D.h., wir erhalten keine konto- oder
        kreditkartenbezogenen Informationen, sondern lediglich Informationen mit
        Bestätigung oder Negativbeauskunftung der Zahlung. Unter Umständen
        werden die Daten seitens der Zahlungsdienstleister an
        Wirtschaftsauskunfteien übermittelt. Diese Übermittlung bezweckt die
        Identitäts- und Bonitätsprüfung. Hierzu verweisen wir auf die AGB und
        die Datenschutzhinweise der Zahlungsdienstleister.
      </p>
      <p>
        Für die Zahlungsgeschäfte gelten die Geschäftsbedingungen und die
        Datenschutzhinweise der jeweiligen Zahlungsdienstleister, welche
        innerhalb der jeweiligen Webseiten bzw. Transaktionsapplikationen
        abrufbar sind. Wir verweisen auf diese ebenfalls zwecks weiterer
        Informationen und Geltendmachung von Widerrufs-, Auskunfts- und anderen
        Betroffenenrechten.
      </p>
      <ul>
        <li>
          <strong>Verarbeitete Datenarten:</strong> Bestandsdaten (z.B. der
          vollständige Name, Wohnadresse, Kontaktinformationen, Kundennummer,
          etc.); Zahlungsdaten (z. B. Bankverbindungen, Rechnungen,
          Zahlungshistorie); Vertragsdaten (z. B. Vertragsgegenstand, Laufzeit,
          Kundenkategorie); Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
          Klickpfade, Nutzungsintensität und -frequenz, verwendete Gerätetypen
          und Betriebssysteme, Interaktionen mit Inhalten und Funktionen).
          Meta-, Kommunikations- und Verfahrensdaten (z. B. IP-Adressen,
          Zeitangaben, Identifikationsnummern, beteiligte Personen).
        </li>
        <li>
          <strong>Betroffene Personen:</strong> Leistungsempfänger und
          Auftraggeber; Geschäfts- und Vertragspartner. Interessenten.
        </li>
        <li>
          <strong>Zwecke der Verarbeitung:</strong> Erbringung vertraglicher
          Leistungen und Erfüllung vertraglicher Pflichten. Geschäftsprozesse
          und betriebswirtschaftliche Verfahren.
        </li>
        <li>
          <strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend
          Angaben im Abschnitt "Allgemeine Informationen zur Datenspeicherung
          und Löschung".
        </li>
        <li>
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und
          vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).
          Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
        </li>
      </ul>
      <p>
        <strong>
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
        </strong>
      </p>
      <ul>
        <li>
          <strong>PayPal: </strong>Zahlungsdienstleistungen (technische
          Anbindung von Online-Bezahlmethoden) (z. B. PayPal, PayPal Plus,
          Braintree); <strong>Dienstanbieter:</strong> PayPal (Europe) S.à r.l.
          et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg;{" "}
          <span>
            <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und
            vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO);{" "}
          </span>
          <strong>Website:</strong>{" "}
          <a href="https://www.paypal.com/de" target="_blank" rel="noreferrer">
            https://www.paypal.com/de
          </a>
          . <strong>Datenschutzerklärung:</strong>{" "}
          <a
            href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"
            target="_blank"
            rel="noreferrer"
          >
            <div>https://www.paypal.com/de/webapps/mpp/ua/privacy-full</div>
          </a>
          .
        </li>
      </ul>
      <h3 id="m225">Bereitstellung des Onlineangebots und Webhosting</h3>
      <p>
        Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur
        Verfügung stellen zu können. Zu diesem Zweck verarbeiten wir die
        IP-Adresse des Nutzers, die notwendig ist, um die Inhalte und Funktionen
        unserer Online-Dienste an den Browser oder das Endgerät der Nutzer zu
        übermitteln.
      </p>
      <ul>
        <li>
          <strong>Verarbeitete Datenarten:</strong> Nutzungsdaten (z. B.
          Seitenaufrufe und Verweildauer, Klickpfade, Nutzungsintensität und
          -frequenz, verwendete Gerätetypen und Betriebssysteme, Interaktionen
          mit Inhalten und Funktionen); Meta-, Kommunikations- und
          Verfahrensdaten (z. B. IP-Adressen, Zeitangaben,
          Identifikationsnummern, beteiligte Personen); Protokolldaten (z. B.
          Logfiles betreffend Logins oder den Abruf von Daten oder
          Zugriffszeiten.). Inhaltsdaten (z. B. textliche oder bildliche
          Nachrichten und Beiträge sowie die sie betreffenden Informationen, wie
          z. B. Angaben zur Autorenschaft oder Zeitpunkt der Erstellung).
        </li>
        <li>
          <strong>Betroffene Personen:</strong> Nutzer (z. B. Webseitenbesucher,
          Nutzer von Onlinediensten).
        </li>
        <li>
          <strong>Zwecke der Verarbeitung:</strong> Bereitstellung unseres
          Onlineangebotes und Nutzerfreundlichkeit; Informationstechnische
          Infrastruktur (Betrieb und Bereitstellung von Informationssystemen und
          technischen Geräten (Computer, Server etc.).). Sicherheitsmaßnahmen.
        </li>
        <li>
          <strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend
          Angaben im Abschnitt "Allgemeine Informationen zur Datenspeicherung
          und Löschung".
        </li>
        <li>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs.
          1 S. 1 lit. f) DSGVO).
        </li>
      </ul>
      <p>
        <strong>
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
        </strong>
      </p>
      <ul>
        <li>
          <strong>
            Bereitstellung Onlineangebot auf gemietetem Speicherplatz:
          </strong>
          Für die Bereitstellung unseres Onlineangebotes nutzen wir
          Speicherplatz, Rechenkapazität und Software, die wir von einem
          entsprechenden Serveranbieter (auch "Webhoster" genannt) mieten oder
          anderweitig beziehen;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO).
          </span>
        </li>
        <li>
          <strong>Erhebung von Zugriffsdaten und Logfiles: </strong>Der Zugriff
          auf unser Onlineangebot wird in Form von sogenannten "Server-Logfiles"
          protokolliert. Zu den Serverlogfiles können die Adresse und der Name
          der abgerufenen Webseiten und Dateien, Datum und Uhrzeit des Abrufs,
          übertragene Datenmengen, Meldung über erfolgreichen Abruf, Browsertyp
          nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor
          besuchte Seite) und im Regelfall IP-Adressen und der anfragende
          Provider gehören. Die Serverlogfiles können zum einen zu
          Sicherheitszwecken eingesetzt werden, z. B. um eine Überlastung der
          Server zu vermeiden (insbesondere im Fall von missbräuchlichen
          Angriffen, sogenannten DDoS-Attacken), und zum anderen, um die
          Auslastung der Server und ihre Stabilität sicherzustellen;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO).
          </span>
          <strong>Löschung von Daten:</strong> Logfile-Informationen werden für
          die Dauer von maximal 30 Tagen gespeichert und danach gelöscht oder
          anonymisiert. Daten, deren weitere Aufbewahrung zu Beweiszwecken
          erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen
          Vorfalls von der Löschung ausgenommen.
        </li>
        <li>
          <strong>E-Mail-Versand und -Hosting: </strong>Die von uns in Anspruch
          genommenen Webhosting-Leistungen umfassen ebenfalls den Versand, den
          Empfang sowie die Speicherung von E-Mails. Zu diesen Zwecken werden
          die Adressen der Empfänger sowie Absender als auch weitere
          Informationen betreffend den E-Mailversand (z. B. die beteiligten
          Provider) sowie die Inhalte der jeweiligen E-Mails verarbeitet. Die
          vorgenannten Daten können ferner zu Zwecken der Erkennung von SPAM
          verarbeitet werden. Wir bitten darum, zu beachten, dass E-Mails im
          Internet grundsätzlich nicht verschlüsselt versendet werden. Im
          Regelfall werden E-Mails zwar auf dem Transportweg verschlüsselt, aber
          (sofern kein sogenanntes Ende-zu-Ende-Verschlüsselungsverfahren
          eingesetzt wird) nicht auf den Servern, von denen sie abgesendet und
          empfangen werden. Wir können daher für den Übertragungsweg der E-Mails
          zwischen dem Absender und dem Empfang auf unserem Server keine
          Verantwortung übernehmen;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO).
          </span>
        </li>
        <li>
          <strong>STRATO: </strong>Leistungen auf dem Gebiet der Bereitstellung
          von informationstechnischer Infrastruktur und verbundenen
          Dienstleistungen (z. B. Speicherplatz und/oder Rechenkapazitäten);
          <strong>Dienstanbieter:</strong> STRATO AG, Pascalstraße 10,10587
          Berlin, Deutschland;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO);
          </span>
          <strong>Website:</strong>
          <a href="https://www.strato.de" target="_blank" rel="noreferrer">
            https://www.strato.de
          </a>
          ;{" "}
          <div>
            <strong>Datenschutzerklärung:</strong>
          </div>
          <a
            href="https://www.strato.de/datenschutz/"
            target="_blank"
            rel="noreferrer"
          >
            https://www.strato.de/datenschutz/
          </a>
          . <strong>Auftragsverarbeitungsvertrag:</strong> Wird vom
          Dienstanbieter bereitgestellt.
        </li>
      </ul>
      <h3 id="m182">Kontakt- und Anfrageverwaltung</h3>
      <p>
        Bei der Kontaktaufnahme mit uns (z. B. per Post, Kontaktformular,
        E-Mail, Telefon oder via soziale Medien) sowie im Rahmen bestehender
        Nutzer- und Geschäftsbeziehungen werden die Angaben der anfragenden
        Personen verarbeitet, soweit dies zur Beantwortung der Kontaktanfragen
        und etwaiger angefragter Maßnahmen erforderlich ist.
      </p>
      <ul>
        <li>
          <strong>Verarbeitete Datenarten:</strong> Bestandsdaten (z. B. der
          vollständige Name, Wohnadresse, Kontaktinformationen, Kundennummer,
          etc.); Kontaktdaten (z. B. Post- und E-Mail-Adressen oder
          Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche
          Nachrichten und Beiträge sowie die sie betreffenden Informationen, wie
          z. B. Angaben zur Autorenschaft oder Zeitpunkt der Erstellung);
          Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer, Klickpfade,
          Nutzungsintensität und -frequenz, verwendete Gerätetypen und
          Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Meta-,
          Kommunikations- und Verfahrensdaten (z. B. IP-Adressen, Zeitangaben,
          Identifikationsnummern, beteiligte Personen).
        </li>
        <li>
          <strong>Betroffene Personen:</strong> Kommunikationspartner.
        </li>
        <li>
          <strong>Zwecke der Verarbeitung:</strong> Kommunikation;
          Organisations- und Verwaltungsverfahren; Feedback (z. B. Sammeln von
          Feedback via Online-Formular). Bereitstellung unseres Onlineangebotes
          und Nutzerfreundlichkeit.
        </li>
        <li>
          <strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend
          Angaben im Abschnitt "Allgemeine Informationen zur Datenspeicherung
          und Löschung".
        </li>
        <li>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs.
          1 S. 1 lit. f) DSGVO). Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).
        </li>
      </ul>
      <p>
        <strong>
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
        </strong>
      </p>
      <ul>
        <li>
          <strong>Kontaktformular: </strong>Bei Kontaktaufnahme über unser
          Kontaktformular, per E-Mail oder anderen Kommunikationswegen,
          verarbeiten wir die uns übermittelten personenbezogenen Daten zur
          Beantwortung und Bearbeitung des jeweiligen Anliegens. Dies umfasst in
          der Regel Angaben wie Name, Kontaktinformationen und gegebenenfalls
          weitere Informationen, die uns mitgeteilt werden und zur angemessenen
          Bearbeitung erforderlich sind. Wir nutzen diese Daten ausschließlich
          für den angegebenen Zweck der Kontaktaufnahme und Kommunikation;
          <span>
            <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und
            vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO),
            Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </span>
        </li>
      </ul>
      <h3 id="m136">Präsenzen in sozialen Netzwerken (Social Media)</h3>
      <p>
        Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und
        verarbeiten in diesem Rahmen Nutzerdaten, um mit den dort aktiven
        Nutzern zu kommunizieren oder Informationen über uns anzubieten.
      </p>
      <p>
        Wir weisen darauf hin, dass dabei Nutzerdaten außerhalb des Raumes der
        Europäischen Union verarbeitet werden können. Hierdurch können sich für
        die Nutzer Risiken ergeben, weil so zum Beispiel die Durchsetzung der
        Nutzerrechte erschwert werden könnte.
      </p>
      <p>
        Ferner werden die Daten der Nutzer innerhalb sozialer Netzwerke im
        Regelfall für Marktforschungs- und Werbezwecke verarbeitet. So können
        beispielsweise anhand des Nutzungsverhaltens und sich daraus ergebender
        Interessen der Nutzer Nutzungsprofile erstellt werden. Letztere finden
        möglicherweise wiederum Verwendung, um etwa Werbeanzeigen innerhalb und
        außerhalb der Netzwerke zu schalten, die mutmaßlich den Interessen der
        Nutzer entsprechen. Daher werden im Regelfall Cookies auf den Rechnern
        der Nutzer gespeichert, in denen das Nutzungsverhalten und die
        Interessen der Nutzer gespeichert werden. Zudem können in den
        Nutzungsprofilen auch Daten unabhängig der von den Nutzern verwendeten
        Geräten gespeichert werden (insbesondere, wenn sie Mitglieder der
        jeweiligen Plattformen und dort eingeloggt sind).
      </p>
      <p>
        Für eine detaillierte Darstellung der jeweiligen Verarbeitungsformen und
        der Widerspruchsmöglichkeiten (Opt-out) verweisen wir auf die
        Datenschutzerklärungen und Angaben der Betreiber der jeweiligen
        Netzwerke.
      </p>
      <p>
        Auch im Fall von Auskunftsanfragen und der Geltendmachung von
        Betroffenenrechten weisen wir darauf hin, dass diese am effektivsten bei
        den Anbietern geltend gemacht werden können. Nur Letztere haben jeweils
        Zugriff auf die Nutzerdaten und können direkt entsprechende Maßnahmen
        ergreifen und Auskünfte geben. Sollten Sie dennoch Hilfe benötigen, dann
        können Sie sich an uns wenden.
      </p>
      <ul>
        <li>
          <strong>Verarbeitete Datenarten:</strong> Kontaktdaten (z. B. Post-
          und E-Mail-Adressen oder Telefonnummern); Inhaltsdaten (z. B.
          textliche oder bildliche Nachrichten und Beiträge sowie die sie
          betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder
          Zeitpunkt der Erstellung). Nutzungsdaten (z. B. Seitenaufrufe und
          Verweildauer, Klickpfade, Nutzungsintensität und -frequenz, verwendete
          Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und
          Funktionen).
        </li>
        <li>
          <strong>Betroffene Personen:</strong> Nutzer (z. B. Webseitenbesucher,
          Nutzer von Onlinediensten).
        </li>
        <li>
          <strong>Zwecke der Verarbeitung:</strong> Kommunikation; Feedback
          (z. B. Sammeln von Feedback via Online-Formular).
          Öffentlichkeitsarbeit.
        </li>
        <li>
          <strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend
          Angaben im Abschnitt "Allgemeine Informationen zur Datenspeicherung
          und Löschung".
        </li>
        <li>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs.
          1 S. 1 lit. f) DSGVO).
        </li>
      </ul>
      <p>
        <strong>
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
        </strong>
      </p>
      <ul>
        <li>
          <div>
            <strong>LinkedIn: </strong>Soziales Netzwerk - Wir sind gemeinsam
            mit LinkedIn Irland Unlimited Company für die Erhebung (jedoch nicht
            die weitere Verarbeitung) von Daten der Besucher, die zu Zwecken der
            Erstellung der „Page-Insights" (Statistiken) unserer
            LinkedIn-Profile erstellt werden, verantwortlich. Zu diesen Daten
            gehören Informationen zu den Arten von Inhalten, die Nutzer sich
            ansehen oder mit denen sie interagieren, oder die von ihnen
            vorgenommenen Handlungen sowie Informationen über die von den
            Nutzern genutzten Geräte (z. B. IP-Adressen, Betriebssystem,
            Browsertyp, Spracheinstellungen, Cookie-Daten) und Angaben aus dem
            Profil der Nutzer, wie Berufsfunktion, Land, Branche,
            Hierarchieebene, Unternehmensgröße und Beschäftigungsstatus.
            Datenschutzinformationen zur Verarbeitung von Daten der Nutzer durch
            LinkedIn können den Datenschutzhinweisen von LinkedIn entnommen
            werden:
          </div>
          <a
            href="https://www.linkedin.com/legal/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            https://www.linkedin.com/legal/privacy-policy
          </a>
          <div>
            Wir haben mit LinkedIn Irland eine spezielle Vereinbarung
            abgeschlossen ("Page Insights Joint Controller Addendum (the
            ‚Addendum‘)",
          </div>
          <a
            href="https://legal.linkedin.com/pages-joint-controller-addendum"
            target="_blank"
            rel="noreferrer"
          >
            https://legal.linkedin.com/pages-joint-controller-addendum
          </a>
          ), in der insbesondere geregelt wird, welche Sicherheitsmaßnahmen
          LinkedIn beachten muss und in der LinkedIn sich bereit erklärt hat die
          Betroffenenrechte zu erfüllen (d. h. Nutzer können z. B. Auskünfte
          oder Löschungsanfragen direkt an LinkedIn richten). Die Rechte der
          Nutzer (insbesondere auf Auskunft, Löschung, Widerspruch und
          Beschwerde bei zuständiger Aufsichtsbehörde), werden durch die
          Vereinbarungen mit LinkedIn nicht eingeschränkt. Die gemeinsame
          Verantwortlichkeit beschränkt sich auf die Erhebung der Daten durch
          und die Übermittlung an die Ireland Unlimited Company, ein Unternehmen
          mit Sitz in der EU. Die weitere Verarbeitung der Daten obliegt
          ausschließlich der Ireland Unlimited Company, was insbesondere die
          Übermittlung der Daten an die Muttergesellschaft LinkedIn Corporation
          in den USA betrifft; <strong>Dienstanbieter:</strong> LinkedIn Ireland
          Unlimited Company, Wilton Place, Dublin 2, Irland;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO);
          </span>
          <strong>Website:</strong>
          <a href="https://www.linkedin.com" target="_blank" rel="noreferrer">
            https://www.linkedin.com
          </a>
          ;{" "}
          <div>
            <strong>Datenschutzerklärung:</strong>
          </div>
          <a
            href="https://www.linkedin.com/legal/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            https://www.linkedin.com/legal/privacy-policy
          </a>
          ;{" "}
          <div>
            <strong>Grundlage Drittlandtransfers:</strong> Data Privacy
            Framework (DPF). <strong>Widerspruchsmöglichkeit (Opt-Out):</strong>
          </div>
          <a
            href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
            target="_blank" rel="noreferrer"
          >
            https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
          </a>
          .
        </li>
        <li>
          <strong>Xing: </strong>Soziales Netzwerk;
          <strong>Dienstanbieter:</strong> New Work SE, Am Strandkai 1, 20457
          Hamburg, Deutschland;
          <span>
            <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6
            Abs. 1 S. 1 lit. f) DSGVO);
          </span>
          <strong>Website:</strong>
          <a href="https://www.xing.com/" target="_blank" rel="noreferrer">
            https://www.xing.com/
          </a>
          . <strong>Datenschutzerklärung:</strong>
          <a
            href="https://privacy.xing.com/de/datenschutzerklaerung"
            target="_blank"
            rel="noreferrer"
          >
            <div>https://privacy.xing.com/de/ datenschutzerklaerung.</div>
          </a>
        </li>
      </ul>
      <p>
        <a
          href="https://datenschutz-generator.de/"
          title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken."
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas
          Schwenke
        </a>
      </p>
    </div>
  );
};
